import { render, staticRenderFns } from "./CoreInput.vue?vue&type=template&id=daf94812&scoped=true"
import script from "./CoreInput.vue?vue&type=script&lang=js"
export * from "./CoreInput.vue?vue&type=script&lang=js"
import style0 from "./CoreInput.vue?vue&type=style&index=0&id=daf94812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf94812",
  null
  
)

export default component.exports